'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _players = require('../../store/actions/players');

var dataHudlElement = 'vi-controls-fullscreen';

var enterFullscreenIconName = 'enterFullscreen';
var exitFullscreenIconName = 'exitFullscreen';

var mapStateToProps = function mapStateToProps(state, ownProps, _ref) {
  var playerId = _ref.playerId;
  var fullscreen = state.players[playerId].fullscreen;

  return {
    isHidden: /Mobi/.test(ownProps.userAgentOverride || navigator.userAgent),
    title: fullscreen ? 'vi.player.controls.exit_fullscreen' : 'vi.player.controls.enter_fullscreen',
    iconName: fullscreen ? exitFullscreenIconName : enterFullscreenIconName,
    dataHudlElement: dataHudlElement
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref2) {
  var playerId = _ref2.playerId;

  return {
    onClick: function onClick() {
      dispatch((0, _players.toggleFullscreen)(playerId));
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];